import { render, staticRenderFns } from "./apparel.vue?vue&type=template&id=1db7ab77&scoped=true"
import script from "./apparel.vue?vue&type=script&lang=js"
export * from "./apparel.vue?vue&type=script&lang=js"
import style0 from "./apparel.vue?vue&type=style&index=0&id=1db7ab77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7ab77",
  null
  
)

export default component.exports